// HOTFIX: Build version for cache-busting and version tracking
// This file is auto-generated or manually updated on each deployment

// Safe defaults - never crash if these are missing
export const BUILD_VERSION = '2026.02.02.2' || 'unknown';
export const BUILD_TIMESTAMP = '2026-02-02T21:10:00Z' || new Date().toISOString();

// Log build version on app start (safely)
if (typeof window !== 'undefined') {
  try {
    console.log(`🚀 CRM Build Version: ${BUILD_VERSION} (${BUILD_TIMESTAMP})`);
    
    // Store in window for debugging
    window.__CRM_BUILD_VERSION__ = BUILD_VERSION;
    window.__CRM_BUILD_TIMESTAMP__ = BUILD_TIMESTAMP;
  } catch (e) {
    console.warn('Failed to log build version:', e);
  }
}
